<script setup>
import { onMounted } from 'vue';
import { useRoute } from 'vue-router';


function goToAppStore() {
  let storeUrl = 'https://play.google.com/store/apps/details?id=com.smartac.pro.app.com';
  if (/iPhone/i.test(navigator.userAgent)) {
    storeUrl = 'https://apps.apple.com/ca/app/smartac-com-pro/id1536845908';
  }
  window.location.href = storeUrl;
}

function handleRedirect() {
  window.location.href = `com.smac.pro:/${this.$route.fullPath}`;
  setTimeout(goToAppStore, 2500);
}

onMounted(handleRedirect);
</script>

<template>
  <section id="redirect-to-app">
    <img
      class="logo"
      src="@shared/assets/img/logo/white-logo.png"
      alt="SmartAC.com"
    >
    <div class="dp-body">
      Download the <b>SmartAC.com Pro</b> app from
      <a class="app-link" :href="'https://apps.apple.com/ca/app/smartac-com-pro/id1536845908'">Apple's App Store</a> or
      <a class="app-link" :href="'https://play.google.com/store/apps/details?id=com.smartac.pro.app.com'">Google's Play Store</a> to access this feature
    </div>
    <div class="dp-button-container">
      <a
        class="app-link"
        :href="'https://play.google.com/store/apps/details?id=com.smartac.pro.app.com'"
      >
        <img src="@shared/assets/img/general/playstore.png" alt="Play Store" class="app-store" />
      </a>
      <a
        class="app-link"
        :href="'https://apps.apple.com/ca/app/smartac-com-pro/id1536845908'"
      >
        <img src="@shared/assets/img/general/appstore.png" alt="App Store" class="app-store" />
      </a>
    </div>
    <img
      class="feature-img"
      src="@shared/assets/img/pro/home.png"
      alt="My Tech"
    >
  </section>
</template>

<style lang="scss">
body{
  background-color: white;
}
section#redirect-to-app {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px 18px;
  .logo {
    width: 184px;
  }
  .dp-body {
    margin: 24px 0;
    font-size: 1.25rem;
    color: white;
    text-align: center;
    line-height: 1.4;
    max-width: 500px;
    .app-link {
      color: $NBLUE100;
    }
  }
  .dp-button-container {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    .app-link {
      &:first-child {
        margin-right: 12px;
      }
      img {
        height: 42px;
        object-fit: contain;
      }
    }
  }
  .feature-img {
    width: 80%;
    max-width: 300px;
  }
}

</style>